let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5TWKd")).then(() => parcelRequire('1yhfK'));